
import Loading from 'vux/src/components/loading/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XNumber from 'vux/src/components/x-number/index.vue'
import Selector from 'vux/src/components/selector/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import PopupRadio from 'vux/src/components/popup-radio/index.vue'

import { getInvestorAgency } from 'api/investor'
import OneLook from './OneLook.vue'
export default {
components: {
Loading,
Group,
XHeader,
XInput,
Selector,
XNumber,
Datetime,
XButton,
OneLook,
PopupRadio
},
data () {
return {
hasResp: false,
localValidity: '存在有效期',
finance: [
'保险机构', '上市公司', '信托公司', '证券公司', '期货公司', '基金管理公司',
'基金管理公司子公司', '银行', '财务公司', '证券公司子公司', '期货公司子公司', '私募基金管理人'
],
otherOrg: [
'非金融机构企业法人', '机关法人', '事业单位法人', '社会团体法人', '非金融类非法人机构', '其他境内金融机构',
'境外代理人', '境外金融机构', '外国战略投资者', '境外非金融机构', '其它'
],
managerOrg: [
'私募基金管理人'
],

orgTypeArry: [],

orgCardArry: ['组织机构代码', '营业执照', '行政机关', '社会团体', '军队', '武警', '下属机构(具有主管单位批文号)', '基金会', '其它'],


loading: true,





baseInfo: {
type: 1, // 1新增 0 查看
isNormal: 1,
invenstemType: 'SPECIFIC_PERSONAL_ORDINARY',
userId: 1755,
isShowBtn: false,
invenstemUserId: 2023,
stepCurrent: 1,
stepTotal: 4,
au: 'eUJpWXhmNTJZMWtya0NDNDF5QjlwTThJcnFPWTdzMUhxdEc0dktXdHl3ZUtGSW4vZmVSaERDS0N4aWJreWl1Tw==',
orgType: 'fund'
},
BusinessScope: [
'农、林、牧、渔业', '采矿业', '制造业', '电力、燃气及水的生产和供应业', '建筑业', '交通运输、仓储和邮政业',
'信息传输、计算机服务和软件业', '批发和零售业', '住宿和餐饮业', '金融业', '房地产业', '租赁和商务服务业', '科学研究、技术服务和地质勘查业', '水利、环境和公共设施管理业',
'居民服务和其他服务业', '教育', '卫生、社会保障和社会福利业', '文化、体育和娱乐业', '公共管理与社会组织', '国际组织'
],
data: {
orgName: '',
orgType: '',
orgDocumentsType: '组织机构代码',
orgDocumentsNo: '',
orgDocumentsValidity: '',
orgQualificationProve: '',
orgQualificationNo: '',
orgBusinessScope: '农、林、牧、渔业',
orgRegisterAddress: '',
orgAddress: '',
orgRegisteredCapital: '',
orgController: ''
},
valid: {
orgName: false,
orgType: false,
orgDocumentsType: false,
orgDocumentsNo: false,
orgDocumentsValidity: false,
orgQualificationProve: false,
orgQualificationNo: false,
orgBusinessScope: false,
orgRegisterAddress: false,
orgAddress: false,
orgRegisteredCapital: false,
orgController: false
}
}
},
watch: {
localValidity: function (val, oldVal) {
if (val === '永久有效') {
this.data.orgDocumentsValidity = val
} else {
this.data.orgDocumentsValidity = ''
}
}
},
created () {
this.$vux.loading.show({text: '加载中'})
setTimeout(() => {
this.$bridge.registerHandler('getUpdate', this.$_agency_update)
this.$_agency_init()
}, this.initTime)
},
methods: {
$_agency_update () {
this.baseInfo.type = 1
},
$_agency_init () {
let _this = this

if (_this.isDev) {
if (_this.baseInfo.type === 0) {
_this.$_agency_info(this.baseInfo.userId, this.baseInfo.invenstemUserId, _this.baseInfo.au)
}
_this.loading = false
_this.$vux.loading.hide()
} else {
let info = `新增/查看投资者信息,
参数
type（1 新增, 0 查看),
isNormal(1是 0 否，string类型),
userId(用户Id),
invenstemUserId(理财师拥有的投资者ID,新增没有就不传),
invenstemType(投资者特定对象认证类型),
au`
_this.$bridge.callHandler('getUserInfo', {message: info}, function (data) {
_this.loading = false
_this.$vux.loading.hide()
const res = JSON.parse(data)
console.log(res, 'org')
if (res.type && res.isNormal && res.userId && res.invenstemType && res.au) {
_this.baseInfo.isShowBtn = parseInt(res.isShowBtn || 0)
_this.baseInfo.type = parseInt(res.type)
_this.baseInfo.isNormal = parseInt(res.isNormal)
_this.baseInfo.userId = res.userId
_this.baseInfo.invenstemType = res.invenstemType
_this.baseInfo.invenstemUserId = res.invenstemUserId
_this.baseInfo.au = res.au
_this.baseInfo.stepCurrent = parseInt(res.stepCurrent)
_this.baseInfo.stepTotal = parseInt(res.stepTotal)
_this.baseInfo.orgType = res.orgType
_this.getOrgList(res.invenstemType)
if (_this.baseInfo.type === 0) {
_this.$_agency_info(res.userId, res.invenstemUserId, res.globalVersion, res.au)
}
} else {
_this.$vux.toast.show({type: 'warn', text: '信息获取失败'})
}
})
}
},
getOrgList (invenstemType) {
switch (invenstemType) {
case 'SPECIFIC_ORG_ORG':       // 金融机构
this.orgTypeArry = this.finance
this.data.orgType = this.finance[0]
break
case 'SPECIFIC_ORG_PRACTITIONERS':   // 管理人
this.orgTypeArry = this.managerOrg
this.data.orgType = this.managerOrg[0]
break
default:
this.orgTypeArry = this.otherOrg
this.data.orgType = this.otherOrg[0]
break
}
},
$_agency_info (userId, invenstemUserId, globalVersion, au) {
getInvestorAgency({userId: userId, invenstemUserId: invenstemUserId, globalVersion: globalVersion}, au).then((res) => {
if (res.code === 0) {
this.data = {
orgName: res.data.bean.orgName,
orgType: res.data.bean.orgType,
orgDocumentsType: res.data.bean.orgDocumentsType,
orgDocumentsNo: res.data.bean.orgDocumentsNo,
orgDocumentsValidity: res.data.bean.orgDocumentsValidity,
orgQualificationProve: res.data.bean.orgQualificationProve,
orgQualificationNo: res.data.bean.orgQualificationNo,
orgBusinessScope: res.data.bean.orgBusinessScope,
orgRegisterAddress: res.data.bean.orgRegisterAddress,
orgAddress: res.data.bean.orgAddress,
orgRegisteredCapital: res.data.bean.orgRegisteredCapital,
orgController: res.data.bean.orgController,
oldInfo: JSON.stringify(res.data.bean)
}
this.hasResp = true
} else {
this.$vux.toast.show({
type: 'warn',
text: '信息获取失败'
})
}
})
},
$_agency_next () {
let _this = this
if (_this.baseInfo.type === 0) {
_this.data.type = this.baseInfo.type
_this.data.isNormal = this.baseInfo.isNormal
_this.data.invenstemType = this.baseInfo.invenstemType
_this.data.userId = this.baseInfo.userId
_this.data.invenstemUserId = this.baseInfo.invenstemUserId
_this.data.au = this.baseInfo.au
_this.$router.push({path: '/investor/agency/two', query: _this.data})
} else {
for (var item in _this.valid) {
console.log(_this.data[item])
if (_this.data[item] === '') {
_this.$vux.toast.show({type: 'warn', text: _this.$refs[item].title + '为空或输入不合规范'})
return
}
}
_this.data.type = this.baseInfo.type
_this.data.isNormal = this.baseInfo.isNormal
_this.data.invenstemType = this.baseInfo.invenstemType
_this.data.userId = this.baseInfo.userId
_this.data.invenstemUserId = this.baseInfo.invenstemUserId
_this.data.au = this.baseInfo.au
_this.$router.push({path: '/investor/agency/two', query: _this.data})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/InvestorInfo/Agency/One.vue